<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="bg-white p-3">
        <h5 class="card-title fw-bold mb-0">Qwilr Blocks</h5>
      </div>  
      <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
        
        <div class="d-sm-flex align-items-center">
        </div>
        <div class="d-sm-flex align-items-center mt-10 mt-lg-0">
          
          <button @click="openAddQwilrBlockBox" class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none">
          Add Block
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          </button>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive" style="overflow: visible;">
          <table class="table text-nowrap align-middle mb-0">
            <colgroup>
              <col style="width: 33%;">
              <col style="width: 33%;">
              <col style="width: 33%;">
              <col style="width: 1%;">
            </colgroup>
            <thead>
              <tr>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Qwilr Block Id
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Title
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Description
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="qwilrDefinitionBlock in filteredQwilrDefinitionBlocks" :key="qwilrDefinitionBlock.id">
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ qwilrDefinitionBlock.qwilrElementId }}
                </th>
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ qwilrDefinitionBlock.title }}
                </th>
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ qwilrDefinitionBlock.description }}
                </th>
                
                <td class="shadow-none lh-1 fw-medium text-end pe-0">
                  <div class="dropdown">
                    <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="flaticon-dots"></i>
                    </button>
                    <ul class="dropdown-menu">
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="#" @click.prevent="deleteBlock(qwilrDefinitionBlock.id)"
                          ><i
                            class="flaticon-delete lh-1 me-8 position-relative top-1"
                          ></i>
                          Delete</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="#" @click.prevent="openUpdateQwilrBlockBox(qwilrDefinitionBlock)"
                          ><i
                            class="flaticon-edit lh-1 me-8 position-relative top-1"
                          ></i>
                          Update</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="#" @click.prevent="goToQwilrSubstitutionMapping(qwilrDefinitionBlock.id)"
                          ><i
                            class="flaticon-settings lh-1 me-8 position-relative top-1"
                          ></i>
                          Substitution Mapping</a
                        >
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
          <p class="mb-0 text-paragraph">
            Showing <span class="fw-bold">{{ filteredQwilrDefinitionBlocks.length }}</span> out of
            <span class="fw-bold">{{ totalQwilrDefinitionBlocks }}</span> results
          </p>
        </div>
      </div>

      <Lightbox v-if="showAddQwilrBlockBox" @close="closeAddQwilrBlockBox">
        <AddQwilrDefinitionBlock :qwilrDefinitionId="this.qwilrDefinitionId" @blockAdded="handleBlockAdded" @close="closeAddQwilrBlockBox"/>
      </Lightbox>
      <Lightbox v-if="showUpdateQwilrBlockBox" @close="closeUpdateQwilrBlockBox">
        <UpdateQwilrDefinitionBlock :block="this.selectedBlock" @blockUpdated="handleBlockUpdated" @close="closeUpdateQwilrBlockBox"/>
      </Lightbox>
    </div>

  </template>
  
  <script>
  import { GetQwilrDefinitionElements,DeleteQwilrDefinitionElement } from '@/core/services/entities/qwilr.service'
  import breadcrumbMixin from '@/mixins/BreadcrumbMixin'
  import Lightbox from '@/components/Common/LightboxWrapper.vue';
  import AddQwilrDefinitionBlock from "./AddQwilrDefinitionBlock.vue";
  import UpdateQwilrDefinitionBlock from "./UpdateQwilrDefinitionBlock.vue";
  import { useToast } from 'vue-toastification'
  import Swal from 'sweetalert2';

  export default {
    name: "QwilrDefinitionBlock",
    components: {
        Lightbox,
        AddQwilrDefinitionBlock,
        UpdateQwilrDefinitionBlock
    },
    data() {
      return {
        searchQuery: "", 
        filteredQwilrDefinitionBlocks: [], 
        pageSize: 10, 
        pageIndex: 1, 
        totalQwilrDefinitionBlocks: 0, 
        totalPages: 1, 
        showAddQwilrBlockBox: false,
        selectedBlock:null,
        showUpdateQwilrBlockBox: false,
        qwilrDefinitionId:null
      };
    },
    mixins: [breadcrumbMixin],
    methods: {
      async fetchQwilrBlocksByFilter(filter = "") {
        let isBlock=true;
        let data = await GetQwilrDefinitionElements(this.qwilrDefinitionId, isBlock);
        console.log(data)
        if(data)
        {
          this.filteredQwilrDefinitionBlocks = data.qwilrDefinitionElements;
          this.totalQwilrDefinitionBlocks = data.qwilrDefinitionElements.length;
        }

      },
      handleSearch(event) {
        event.preventDefault();
        const filter = this.searchQuery.trim();
        this.pageIndex = 1; 
        this.fetchQwilrBlocksByFilter(filter);
      },
      changePage(page) {
        if (page > 0 && page <= this.totalPages) {
          this.pageIndex = page;
          this.fetchQwilrBlocksByFilter(this.searchQuery);
        }
      },
      openAddQwilrBlockBox(){
        this.showAddQwilrBlockBox=true;
      },
      openUpdateQwilrBlockBox(block){
        this.selectedBlock=block;
        this.showUpdateQwilrBlockBox=true;
      },
      closeAddQwilrBlockBox(){
        this.showAddQwilrBlockBox=false;
      },
      closeUpdateQwilrBlockBox(){
        this.showUpdateQwilrBlockBox=false;
      },
      handleBlockAdded(){
        this.fetchQwilrBlocksByFilter("");
      },
      handleBlockUpdated(){
        this.fetchQwilrBlocksByFilter("");
      },
      async goToQwilrSubstitutionMapping(elementId) {
        this.$router.push({ name: 'qwilrSubstitutionMappingPage', params: { id: elementId, qwilrDefinitionId:this.qwilrDefinitionId } });
      },
      async deleteBlock(blockId) {
        const toast = useToast();

        // Show confirmation dialog using SweetAlert2
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {  
          if (result.isConfirmed) {
            try {
              const payload = { id: blockId };
              let response = await DeleteQwilrDefinitionElement(payload);  
              if (response.status === 200) {
                toast.success('Block deleted successfully!', {
                  timeout: 2000,
                });
                this.fetchQwilrBlocksByFilter("");
              }
            } catch (ex) {
              const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
              console.log(errorMessage);
              toast.error(`Failed to delete block: ${errorMessage}`, {
                timeout: 2000,
              });
            }
          } else {
            toast.info('Block deletion canceled.', { timeout: 2000 });
          }
        });

      }
    },
    created() {
      this.qwilrDefinitionId = this.$route.params.id;
      this.fetchQwilrBlocksByFilter("");
    }
  };
  </script>


  